export default /electron/i.test(navigator.userAgent);